module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_moere_og_romsdal_neg.f9288afe.pdf";